export const ADD_SLIDE_REQUEST = " ADD_SLIDE_REQUEST";
export const ADD_SLIDE_SUCCESS = " ADD_SLIDE_SUCCESS";
export const ADD_SLIDE_FAILURE = " ADD_SLIDE_FAILURE";
